<template>
	<div class='story' >
		<Menu />
	</div>
</template>

<script>
import Menu from './components/menu-svg';

import './scss/index.scss'

export default {
	name: 'App',
	mounted: function() {},
	components: {
		Menu,
	}
}
</script>